"use client"

import { chakra } from "@chakra-ui/react"
import recipe from "./recipe"

export const Input = chakra("input", recipe);
export default Input
